import { InjectionToken } from '@angular/core';
import type { ObjectEditorService } from './object-editor.service';

/**
 * Runtime handle on ObjectEditorService for consumers that the service's own import
 * graph reaches back into. The grid views are one: ObjectEditorService imports
 * the query editor dialog, whose query-used-by tab is a grid host, so a plain
 * class import from the grid stack is a runtime cycle that leaves a class
 * undefined when the bundler evaluates the consumer first ("Class extends value
 * undefined", seen on the Vite dev server while the grid was still a base class).
 * Provided in AppModule with `useExisting: ObjectEditorService`.
 */
export const OBJECT_EDITOR_SERVICE = new InjectionToken<ObjectEditorService>(
  'ObjectEditorService',
);
